import React from "react";
import { Link } from "react-router-dom";
import { getNotificationUpdates } from "../firebase/firestore";
import withAccount from "../utils/withAccount";

class NavigationSideBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = { unreadNotifications: 0 };

    this.notificationsUnsub = null;
  }

  renderMenuItem(value) {
    const isSelected = this.props.page === value.id;
    return (
      <Link key={value.id} to={`/dash/${value.id}`}>
        <div className={isSelected ? "NavBar-Item-Active" : "NavBar-Item"}>
          <i className={value.icon} />
          <p>{value.label}</p>
          {value.indicator !== null ? <span>{value.indicator}</span> : null}
        </div>
      </Link>
    );
  }

  componentDidMount() {
    this.notificationsUnsub = getNotificationUpdates(
      this.props.account.id,
      true,
      docs => {
        this.setState({ unreadNotifications: docs.docs.length });
      }
    );
  }

  componentWillUnmount() {
    if (this.notificationsUnsub) this.notificationsUnsub();
  }

  render() {
    const { account } = this.props;
    const { unreadNotifications } = this.state;

    let notificationsString = unreadNotifications.toString();
    if (unreadNotifications <= 0) notificationsString = null;
    if (unreadNotifications >= 100)
      notificationsString = <i className="fas fa-exclamation" />;

    const menuItems = [
      {
        id: "notifications",
        label: "Neues",
        icon: "fas fa-bell",
        indicator: notificationsString
      },
      {
        id: "clients",
        label: "Kunden",
        icon: "fas fa-handshake",
        indicator: null
      },
      {
        id: "projects",
        label: "Projekte",
        icon: "fas fa-shapes",
        indicator: null
      },
      {
        id: "users",
        label: "Nutzer",
        icon: "fas fa-users",
        indicator: null
      },
      {
        id: "activities",
        label: "Aktivitäten",
        icon: "fas fa-clipboard-list",
        indicator: null
      },
      {
        id: "reports",
        label: "Berichte herunterladen",
        icon: "fas fa-file-download",
        indicator: null
      },
      {
        id: "settings",
        label: "Einstellungen",
        icon: "fas fa-cog",
        indicator: null
      }
    ];

    const items = menuItems.map(value => this.renderMenuItem(value));

    return (
      <div className="NavBar">
        {items}
        <div id="Foot">
          <p title={`ID: ${account.id}`}>{account.name}</p>
        </div>
      </div>
    );
  }
}

export default withAccount(NavigationSideBar);



// WEBPACK FOOTER //
// ./src/components/NavigationSideBar.js